import $ from 'jquery';

/**
 * CookieBanner class to handle the cookie consent banner logic
 *
 * @module cookie-banner
 * @version 1.0.0
 * @author hello@bradenericson.com
 *
 * Created on 2023-12-14
 */
class CookieBanner {
  constructor(element) {
    this.$el = $(element);
    this.setupBinds();
    this.checkForVisibility();
  }

  setupBinds() {
    this.$acceptButton = this.$el.find('.button');
    this.$acceptButton.on('click', this.onAcceptClick.bind(this));
  }

  checkForVisibility() {
    if (!this.getCookie('cookie-consent')) {
      this.$el.addClass('show');
    }
  }

  onAcceptClick() {
    this.setCookie('cookie-consent', 'true', 365); // Set a cookie for 1 year
    this.$el.addClass('hide');
  }

  setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/';
  }

  getCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
}

export default CookieBanner;
